import React from 'react';


import { Colors } from 'src/styles/DesignSystem';
import CardServico from '../CardServico';
import { ServicesContainer, ServicesWrapper, TitleServices } from './ServicesStyles';

const ServicesSection = ({ title, subtitle, titleColor, padding, services }) => {
    
    return (
        <ServicesContainer padd={padding}>
            <TitleServices titleColor={titleColor}>
                <h2>{title}</h2>
                <p>{subtitle}</p>
            </TitleServices>

            <ServicesWrapper>
                {
                    services.map( (service) => (
                        <CardServico 
                            key = {service.id}
                            link= {`/servicos/${service.slug}`}
                            id={service.id}
                            qtdCards={services.length}
                            bgColor={service.acf.card_bg}
                            img={service.acf.icone}
                            title={service.title.rendered}
                            txtColor={Colors.white}
                        />
                    ))
                }
            </ServicesWrapper>
        </ServicesContainer>
    )
}

export default ServicesSection;